import { Task } from './datatype';

export function isSpecialHabit(habit: Task, specialHabit: string[]): boolean {
  return specialHabit.some((s) => habit.text.search(s) !== -1);
}
